import axios from 'axios'

import { ApiClient } from './client'
import { useBaseUrl } from '#imports'

const serviceBasePath = '/terminierungsportal/appointments/'

export const makeApiClient = (): ApiClient => {
  // FN-3.5.5: auth travels in the HttpOnly `accessToken` cookie — credentialed
  // requests are required because the API host (api.*) differs from the page host.
  const axiosInstance = axios.create({ withCredentials: true })
  const { baseUrl } = useBaseUrl()

  axiosInstance.defaults.baseURL = baseUrl + serviceBasePath
  return new ApiClient(axiosInstance)
}

export { useApi } from './plugin'
